import { AlertDetailsEnum, DashboardTaskAlertTypes } from "../../enums/Tasks.enum";

export interface Tasks {
  title: string;
  count: number;
  alertDetails?: AlertDetails[];
  discrepancies?: Discrepancies;
  alertFilters?: AlertFilters;
  alertDetailsExpectedFields?: Partial<Record<AlertDetailsEnum, IAlertHeaderConfig>>;
  signaturedata?: Signaturedata
}

export interface AlertDetails {
  patientName?: string;
  therapistName?: string;
  date?: string;
  agendaMode?: string;
  agendaTime?: string;
  discipline?: string;
  patientId?: string;
  therapistId?: string;
  documentType?: string;
  errorReason?: string;
  occurrenceCount?: number;
  firstSeenDate?: string;
}

export interface Discrepancies {
  "Forecast Minutes but No Agenda": DiscrepanciesItem[];
  "Forecast Does Not Match Agenda": DiscrepanciesItem[];
  "Patient on Agenda but Not Assigned to Therapist": DiscrepanciesItem[];
}

export interface DiscrepanciesItem {
  name: string;
  agendaMinutes?: number;
  forecastMinutes?: number;
  isTherapistAssigned?: boolean;
  agendaDate?: string;
  discipline?: string;
}

export interface Signaturedata{
  "Documents Pending for Signature": MDSection[];
  "Documents Rejected for Signature": MDSection[];
}

export interface MDSection {
  name?: string;
  documentType?: string;
  discipline?: string;
  activityDate?: string;
  daysInQueue?: number;
  patientId?: string;
  physicianName?: string;
}

export interface ApplyTaskFilters{
  facilityId: string;
  viewType: Number;
  alertType?: DashboardTaskAlertTypes;
  filterAlerts?: AlertFilters;
}

export interface AlertFilters {
  fromDate?: string;
  endDate?: string;
  disciplines?: number[];
  patients?: number[];
  therapists?: number[];
  physicians?: number[];
  dateRange?: string;
}

export interface IAlertHeaderConfig {
  headerName: string;
  isRouteRequired: boolean;
}

export class AlertHeaderConfig implements IAlertHeaderConfig {
  constructor(
      public headerName: string = '',
      public isRouteRequired: boolean = false
  ) {}
}

export interface TherapistDropdownResponse {
  therapistId: number;
  firstName: string;
  lastName: string;
  disciplineIds?: number[];
  therapistTypeId?: number;
}

export interface TherapistDropdownItem {
  id: number;
  name: string;
  disciplines?: number[];
}